module.exports = __webpack_public_path__ + "img/witless_shako.0095430b.png";